import { withInstall } from '@tw-element/utils'
import TreeV2 from './src/tree.vue'

export const TwTreeV2 = withInstall(TreeV2)
export default TwTreeV2
